Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "GroupActivity3507616222",
  {"header":"GroupActivity3507616222--header","activities":"GroupActivity3507616222--activities","activity":"GroupActivity3507616222--activity","divider":"GroupActivity3507616222--divider","root":"GroupActivity3507616222--root"},
  "",
  12,
  "GroupActivity3507616222"
);

